module.exports = __webpack_public_path__ + "static/media/down.314d9b92.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Helpers/Storage/Images/down.svg
// module id = 485
// module chunks = 0